import { AlertResponse } from "../types/media";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { EDS_DATES_ID, PEDS_DATES_ID } from "../hooks/useEdsDatesFilter";

export const checkEdsFilter = (
  alert: AlertResponse | undefined,
  filterValues: FilterValue[],
  edsType: "eds" | "peds",
  now: number = Date.now()
): boolean => {
  if (!alert || !Array.isArray(alert.edsDates) || alert.edsDates.length === 0)
    return false;

  const relevantDates = alert.edsDates.filter((d) =>
    edsType === "eds"
      ? new Date(d).getTime() >= now
      : new Date(d).getTime() < now
  );
  if (relevantDates.length === 0) return false;

  const datesId = edsType === "eds" ? EDS_DATES_ID : PEDS_DATES_ID;
  const selectedValue = filterValues.find((f) => f.filterId === datesId)?.value;

  const noValueSelected =
    selectedValue == null ||
    (typeof selectedValue === "string" && selectedValue.trim() === "") ||
    (Array.isArray(selectedValue) && selectedValue.length === 0);

  if (noValueSelected) {
    return true;
  }

  if (Array.isArray(selectedValue)) {
    return selectedValue.some((v) => relevantDates.includes(String(v)));
  }

  return relevantDates.includes(String(selectedValue));
};
